<template>
  <div class="boxs">
    <div class="datesBox" v-if="multiple">
      <v-dialog v-if="leTbS" ref="dates" v-model="datesMenu" lazy full-width width="290px" content-class="c-full-dlg">
        <v-combobox
          slot="activator"
          v-model="dates"
          :label="dateLabel"
          :hint="dateHint"
          persistent-hint
          multiple
          chips
          small-chips
          :prepend-icon="noIcon ? null : 'event'"
          readonly
          ref="datesInput"
          :error-messages="dateError"
        ></v-combobox>
        <v-date-picker
          v-model="dates"
          :color="readOnly ? 'clr-gray' : 'clr-primary'"
          :locale="userLang"
          :day-format="date => new Date(date).getDate()"
          multiple
          no-title
          :min="minDate"
          :max="maxDate"
          :readonly="readOnly"
          :picker-date="pickerDateTmp"
          scrollable
        >
          <template v-if="!readOnly">
            <v-spacer></v-spacer>
            <v-btn flat small color="primary" @click="$refs.dates.save(dates)">{{ $T('button.ok') }}</v-btn>
            <v-spacer></v-spacer>
          </template>
        </v-date-picker>
      </v-dialog>

      <v-menu
        v-else
        ref="dates"
        :close-on-content-click="false"
        v-model="datesMenu"
        :nudge-right="40"
        lazy
        transition="scale-transition"
        offset-y
        full-width
        min-width="290px"
        :disabled="disabled"
      >
        <v-combobox
          slot="activator"
          v-model="dates"
          multiple
          chips
          small-chips
          :label="dateLabel"
          :hint="dateHint"
          :prepend-icon="noIcon ? null : 'event'"
          readonly
          ref="datesInput"
          :error-messages="dateError"
        ></v-combobox>
        <v-date-picker
          v-model="dates"
          :color="readOnly ? 'clr-gray' : 'clr-primary'"
          :locale="userLang"
          :day-format="date => new Date(date).getDate()"
          :min="minDate"
          :max="maxDate"
          :readonly="readOnly"
          :picker-date="pickerDateTmp"
          multiple
          no-title
          scrollable
        >
          <template v-if="!readOnly">
            <v-spacer></v-spacer>
            <v-btn flat small color="primary" @click="$refs.dates.save(dates)">{{ $T('button.ok') }}</v-btn>
            <v-spacer></v-spacer>
          </template>
        </v-date-picker>
      </v-menu>
    </div>

    <div v-if="!multiple" class="dateBox">
      <v-dialog v-if="leTbS" ref="date" v-model="dateMenu" lazy full-width width="290px" content-class="c-full-dlg">
        <v-text-field
          slot="activator"
          v-model="date"
          :label="dateLabel"
          :prepend-icon="noIcon ? null : 'event'"
          :disabled="disabled"
          readonly
          ref="dateInput"
          :error-messages="dateError"
        ></v-text-field>
        <v-date-picker
          v-model="date"
          no-title
          scrollable
          :color="readOnly ? 'clr-gray' : 'clr-primary'"
          :locale="userLang"
          :day-format="date => new Date(date).getDate()"
          :min="minDate"
          :max="maxDate"
          :readonly="readOnly"
          :picker-date="pickerDateTmp"
          @change="$refs.date.save(date)"
          @input="dateMenu = false"
        ></v-date-picker>
      </v-dialog>

      <v-menu
        v-else
        ref="date"
        :close-on-content-click="false"
        v-model="dateMenu"
        :nudge-right="40"
        lazy
        transition="scale-transition"
        offset-y
        full-width
        min-width="290px"
        :disabled="disabled"
      >
        <v-text-field
          slot="activator"
          v-model="date"
          :label="dateLabel"
          :prepend-icon="noIcon ? null : 'event'"
          :disabled="disabled"
          readonly
          ref="dateInput"
          :error-messages="dateError"
        ></v-text-field>
        <v-date-picker
          v-model="date"
          no-title
          scrollable
          :color="readOnly ? 'clr-gray' : 'clr-primary'"
          :locale="userLang"
          :day-format="date => new Date(date).getDate()"
          :min="minDate"
          :max="maxDate"
          :readonly="readOnly"
          :picker-date="pickerDateTmp"
          @change="$refs.date.save(date)"
          @input="dateMenu = false"
        ></v-date-picker>
      </v-menu>
    </div>
    <div v-if="!multiple" class="timeBox" v-show="!dateOnly">
      <v-dialog v-if="leTbS" ref="time" v-model="timeMenu" lazy full-width width="290px" content-class="c-full-dlg">
        <v-text-field
          slot="activator"
          v-model="time"
          :label="timeLabel"
          :prepend-icon="noIcon ? null : 'access_time'"
          readonly
          :disabled="disabled"
          ref="timeInput"
        ></v-text-field>
        <time-picker
          v-if="timeMenu"
          v-model="time"
          :minSelector="minSelector"
          :readonly="readOnly"
          @ok="timeMenu = false"
          @cancel="timeMenu = false"
        ></time-picker>
      </v-dialog>

      <v-menu
        v-else
        ref="time"
        :close-on-content-click="false"
        v-model="timeMenu"
        :nudge-right="40"
        lazy
        transition="scale-transition"
        offset-y
        full-width
        max-width="290px"
        min-width="290px"
        :disabled="disabled"
      >
        <v-text-field
          slot="activator"
          v-model="time"
          :label="timeLabel"
          :disabled="disabled"
          :prepend-icon="noIcon ? null : 'access_time'"
          readonly
          ref="timeInput"
        ></v-text-field>
        <time-picker
          v-if="timeMenu"
          v-model="time"
          :minSelector="minSelector"
          :readonly="readOnly"
          @ok="timeMenu = false"
          @cancel="timeMenu = false"
        ></time-picker>
      </v-menu>
    </div>
  </div>
</template>

<script>
import { CONST } from '../../constant';
import timePicker from './TimePicker.vue';

export default {
  components: {
    'time-picker': timePicker,
  },
  props: {
    value: { required: false, default: null },
    disabledDate: { type: String, required: false, default: null },
    dateLabel: { type: String, required: false, default: $T('attributes.date') },
    dateHint: { type: String, required: false, default: null },
    errMsg: { type: String, required: false, default: null },
    timeLabel: { type: String, required: false, default: $T('attributes.time') },
    timeHint: { type: String, required: false, default: null },
    useSec: { type: Boolean, required: false, default: false },
    dateOnly: { type: Boolean, required: false, default: false },
    readOnly: { type: Boolean, required: false, default: false },
    noIcon: { type: Boolean, required: false, default: false },
    disabled: { type: Boolean, required: false, default: false },
    minSelector: { type: Boolean, required: false, default: true },
    multiple: { type: Boolean, required: false, default: false },
    minDate: { type: String, required: false, default: null },
    maxDate: { type: String, required: false, default: null },
    pickerDate: { type: String, required: false, default: null },
  },
  data: function() {
    return {
      dates: this.calcInitDates(this.value),
      date: this.calcInitDate(this.value),
      time: this.calcInitTime(this.value),
      datesMenu: false,
      dateMenu: false,
      timeMenu: false,
      pickerDateTmp: this.pickerDate,
    };
  },
  watch: {
    value(n, o) {
      this.date = this.calcInitDate(n);
      this.time = this.calcInitTime(n);
    },
    dates(n, o) {
      this.$emit('input', n);
    },
    date(n, o) {
      this.fireDateTimeVal(n, this.time);
    },
    time(n, o) {
      this.fireDateTimeVal(this.date, n);
    },
    datesMenu(n, o) {
      this.$nextTick(function() {
        if (n) this.pickerDateTmp = null;
        else this.pickerDateTmp = this.pickerDate;
      });
    },
    dateMenu(n, o) {
      this.$nextTick(function() {
        if (n) this.pickerDateTmp = null;
        else this.pickerDateTmp = this.pickerDate;
      });
      if (!n && this.date && !this.time && !this.dateOnly) {
        this.timeMenu = true;
      }
    },
    timeMenu(n, o) {
      if (!n && !this.date && this.time) {
        this.dateMenu = true;
      }
    },
  },
  computed: {
    disabledDates() {
      if (this.disabledDate) {
        return {
          to: new Date(this.disabledDate),
        };
      } else {
        return undefined;
      }
    },
    dateError() {
      return this.errMsg ? [this.errMsg] : null;
    },
  },
  methods: {
    focus() {
      if (this.multiple) {
        this.$refs.datesInput.focus();
        this.datesMenu = true;
      } else {
        this.$refs.dateInput.focus();
        this.dateMenu = true;
      }
    },
    calcInitDates(v) {
      if (!this.multiple || !v) return [];
      return v;
    },
    calcInitDate(v) {
      if (this.multiple || !v) return null;
      return this.$moment(v).format('YYYY-MM-DD');
    },
    calcInitTime(v) {
      if (this.multiple || !v) return null;
      return this.$moment(v).format(this.useSec ? 'HH:mm:ss' : 'HH:mm');
    },
    fireDateTimeVal(d, t) {
      var v = d + ' ' + (this.dateOnly ? (this.useSec ? '00:00:00' : '00:00') : t);
      if (v && d && this.$moment(v).format(this.useSec ? 'YYYY-MM-DD HH:mm:ss' : 'YYYY-MM-DD HH:mm') === v) {
        this.$emit('input', v);
      } else {
        console.warn(`v=${v} is invalid.`);
      }
    },
  },
};
</script>

<style scoped>
.boxs {
  display: flex;
  justify-content: flex-start;
  min-width: 240px;
  max-width: 260px;
}
.dateBox {
  width: 55%;
  flex-grow: 2;
}
.timeBox {
  margin-left: 10px;
  width: 45%;
  flex-grow: 1;
}
</style>
